<div class="driver-actvity-container">

    <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">

        <!-- ===== SECTION DATES ===== -->
        <div class="row" style="padding-top: 0;">
            <!-- Date Début -->
            <div class="form-group" style="margin-bottom: 0; padding: 0 2px;">
                <input 
                    *ngIf="isDateOnly" 
                    type="text" 
                    class="form-control input-sm calender-item" 
                    bsDatepicker 
                    name="startDate" 
                    placeholder="Date Début" 
                    [(ngModel)]="repport.dateInterval.startDate" 
                    [bsConfig]="{
                        dateInputFormat: 'DD-MM-YYYY',
                        containerClass: 'theme-dark-blue'
                    }" 
                                            (ngModelChange)="checkPeriodValidity()"

                    [maxDate]="maxDate" 
                    placement="bottom" 
                    autocomplete="off" />
                    
                <input 
                    *ngIf="!isDateOnly" 
                    type="text" 
                    class="form-control input-sm calender-item" 
                    bsDatepicker 
                    name="startDate" 
                    placeholder="Date Début" 
                    [(ngModel)]="repport.dateInterval.startDate" 
                    [bsConfig]="{
                        dateInputFormat: 'DD-MM-YYYY HH:mm',
                        containerClass: 'theme-dark-blue'
                    }" 
                    [maxDate]="maxDate" 
                                            (ngModelChange)="checkPeriodValidity()"

                    placement="bottom" 
                    autocomplete="off" />
            </div>

            <!-- Date Fin -->
            <div class="form-group" style="margin-bottom: 0; padding: 0 2px;">
                <input 
                    *ngIf="isDateOnly" 
                    type="text" 
                    class="form-control input-sm calender-item" 
                    bsDatepicker 
                    name="endDate" 
                    placeholder="Date Fin" 
                                            (ngModelChange)="checkPeriodValidity()"

                    [(ngModel)]="repport.dateInterval.endDate" 
                    [bsConfig]="{
                        dateInputFormat: 'DD-MM-YYYY',
                        containerClass: 'theme-dark-blue'
                    }" 
                    [minDate]="repport.dateInterval.startDate" 
                    placement="bottom" 
                    autocomplete="off" />
                    
                <input 
                    *ngIf="!isDateOnly" 
                    type="text" 
                    class="form-control input-sm calender-item" 
                    bsDatepicker 
                    name="endDate" 
                    placeholder="Date Fin" 
                    [(ngModel)]="repport.dateInterval.endDate" 
                    [bsConfig]="{
                        dateInputFormat: 'DD-MM-YYYY HH:mm',
                        containerClass: 'theme-dark-blue'
                    }" 
                    [minDate]="repport.dateInterval.startDate" 
                    placement="bottom" 
                    autocomplete="off" 
                    (ngModelChange)="setTimeTo2359();checkPeriodValidity()" />
            </div>
        </div>

        <!-- ===== INPUTS CONTAINER ===== -->
        <div class="inputs-container">

            <!-- Select Rapport (All, By Group, By Vehicule) -->
          <!--   <div>
                <select 
                    class="form-control" 
                    [(ngModel)]="Selectedoption" 
                    (change)="onSelectingReportOf()" 
                    disabled
                    name="selectedoption">
                    <option 
                        style="font-size: 10px; padding: 2px 4px;" 
                        *ngFor="let opt of selectReportOf" 
                        [value]="opt.name">
                        {{ opt.label }}
                    </option>
                </select>
            </div> -->

            <!-- Select Groupes (si byGroups est activé) -->
            <div *ngIf="this.repport.rapportPayloadDto.byGroups">
                <ng-select 
                    *ngIf="groupsItems.length != 0 && multipleSelect" 
                    [items]="groupsItems" 
                    [(ngModel)]="selectedGroupsItems" 
                    [multiple]="true" 
                    bindLabel="text" 
                    bindValue="id" 
                    (data)="selectedGroups($event)" 
                    [clearable]="true" 
                    placeholder="Groupes" 
                    class="ng-select-container">
                </ng-select>
                
                <select 
                    *ngIf="!multipleSelect" 
                    class="form-control" 
                    [(ngModel)]="repport.rapportPayloadDto.idGroup" 
                    name="groups">
                    <option 
                        style="font-size: 10px; padding: 2px 4px;" 
                        *ngFor="let g of groups" 
                        [ngValue]="g.idGroupe">
                        <span *ngIf="g.nameGroupParent">
                            {{ g.nameGroupParent | capitalizefirst | truncate : [30] }} / 
                        </span>
                        {{ g.nom }}
                    </option>
                </select>
            </div>

            <!-- Select Véhicules (si byVehicules est activé) -->
            <div *ngIf="this.repport.rapportPayloadDto.byVehicules">
                <ng-select 
                    *ngIf="vehiculesItems.length != 0 && multipleSelect" 
                    [multiple]="true" 
                    [items]="vehiculesItems" 
                    bindLabel="text" 
                    bindValue="id" 
                    placeholder="Véhicules" 
                    [(ngModel)]="vehiculesSelected" 
                    [clearable]="true" 
                    (data)="selectedVehicules($event)" 
                    class="ng-select-container">
                </ng-select>

                <select 
                    *ngIf="!multipleSelect" 
                    class="form-control" 
                    [(ngModel)]="repport.rapportPayloadDto.idVehicule" 
                    name="vehicules">
                    <option 
                        style="font-size: 10px; padding: 2px 4px;" 
                        *ngFor="let v of vehicules" 
                        [ngValue]="v.idVehicule">
                        {{ v.mark != null && v.mark != "" ? v.mark : v.matricule }}
                    </option>
                </select>
            </div>

        

            <!-- Input Durée -->
            <div>
                <input 
                    type="text" 
                    class="duree-input" 
                    name="duree" 
                    placeholder="Durée (min)" 
                    [(ngModel)]="duree" />
            </div>

        </div>
    </div>

    <!-- ===== BOUTONS D'ACTION ===== -->
    <div class="action-buttons">
  <div >
            <button *ngIf=" !isSending" class="download-button"
                style="background: rgba(6, 129, 163, 0.788); color: beige;" (click)="openAutoSend()">
<i class="fa fa-share-square" style="font-size: 14px;"></i>           </button>
            <div *ngIf="isSending" class="download-button"
                style="background: rgba(6, 129, 163, 0.788);color: beige; size:inherit;">
                <span class="display-loader"></span>
            </div>
        </div>
        <div >
            <button *ngIf=" !isShowingExcel" class="download-button"
                style="background: rgba(0, 128, 0, .788); color: beige;" (click)="showExcel()">
                <i class="fa fa-file-excel-o" style="font-size: 14px;"></i>
            </button>
            <div *ngIf="isShowingExcel" class="download-button"
                style="background: rgba(0, 128, 0, .788);color: beige; size:inherit;">
                <span class="display-loader"></span>
            </div>
        </div>

        <!-- Bouton Télécharger Excel -->
        <div>
            <button 
                            [disabled]="!isPeriodValid"

                *ngIf="!isDownloading" 
                class="download-button" 
                (click)="downloadExcel()">
                <mat-icon style="height: 18px; width: 20px; font-size: 16px; line-height: 18px;">
                    download
                </mat-icon>
            </button>
            
            <div 
                *ngIf="isDownloading" 
                class="download-button">
                <span class="loader"></span>
            </div>
        </div>
    </div>

</div>